import styled from "styled-components"
import {
  border,
  color,
  compose,
  flexbox,
  layout,
  space,
  position,
  typography,
} from "styled-system"

import { Box } from "components/common"

const Select = styled(Box).attrs((props) => ({
  as: "select",
  border: `1px solid ${props.theme.colors.grey10}`,
  ...props,
}))`
  ${compose(border, color, flexbox, layout, space, position, typography)}
  background-color: ${(props) => props.theme.colors.white};
  display: inline-block;
  height: ${(props) => props.height || "46px"};
  outline: none;
  padding: 0 4px;
  vertical-align: top;
`
// :after {
//   position: absolute;
//   top: 5px;
//   right: 6px;
//   z-index: 1;

//   display: block;
//   content: "\\25be";
//   font-size: 14px;
//   color: ${props => props.theme.colors.grey65};
// }

export default Select
